export function isValidLongitude(value: number): boolean {
    return typeof value === "number" && Math.abs(value) <= 180;
}

export function isValidLatitude(value: number): boolean {
    return typeof value === "number" && Math.abs(value) <= 90;
}
